module.exports = __webpack_public_path__ + "img/icon-pdf.a71c35b8.svg";